export const LEGAL_ENTITY = {
  controllerName: 'Thiago de Holanda Theodoro Bustamante',
  nif: '306845890',
  privacyEmail: 'privacy@salovare.com',
  supportEmail: 'support@salovare.com',
  productName: 'Salovare',
  country: 'Portugal',
};
